import { render, staticRenderFns } from "./SocialMediaGroup.vue?vue&type=template&id=7ca70048"
import script from "./SocialMediaGroup.vue?vue&type=script&lang=js"
export * from "./SocialMediaGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports